import "./PostsView.css";
import {
  Row,
  Card,
  Text,
  Divider,
  Collapse,
  Col,
  Spacer,
  Page,
  Loading,
} from "@geist-ui/react";
import {
  // FaRegArrowAltCircleUp,
  FaArrowAltCircleUp,
  // FaArrowAltCircleDown,
  FaRegArrowAltCircleDown,
  FaTrophy,
  FaPlus,
} from "react-icons/fa";
import { Fab } from "@material-ui/core";
import { useState, useEffect } from "react";

import getPosts from "./getPosts";
import { useCookies } from "react-cookie";

function PostsView() {
  const [cookies] = useCookies(["colabAuth"]);
  const [posts, setPosts] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      return;
    }
    setLoading(true);
    const { token } = cookies.colabAuth;
    getPosts(token, setPosts, setLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Collapse.Group>
        {isLoading && <Loading />}
        <RenderPosts posts={posts} />
      </Collapse.Group>
      <Page.Footer>
        <Fab variant="extended" className="fab" color="primary">
          <FaPlus />
          <Spacer x={0.5} />
          Create New
        </Fab>
      </Page.Footer>
    </>
  );
}

function RenderPosts({ posts }) {
  console.log(posts);
  return posts.map(({ id, title, shortDescription, longDescription }) => {
    const subtitle = shortDescription;
    const comments = [643, 112, 10, 444, 6, 13];
    const answers = comments.map((votes, index) => {
      return (
        <>
          <Card id={id}>
            <Card.Content>{longDescription}</Card.Content>
            <Card.Footer>
              <Row justify="end" className="trophyBar">
                <Col span={18}>
                  {index === 0 && (
                    <>
                      <FaTrophy fill="orange" /> Top Voted
                    </>
                  )}
                </Col>
                <Col span={6}>
                  <Text small className="upvoteBar">
                    {`${votes} Upvotes`}
                    <Spacer x={1} />
                    <FaArrowAltCircleUp size="1.5em" fill="blue" />
                    <FaRegArrowAltCircleDown size="1.5em" fill="grey" />
                  </Text>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
          <Divider y={2} volume={0} />
        </>
      );
    });
    return (
      <>
        <Collapse
          width="400"
          shadow
          title={title}
          subtitle={subtitle}
          className="collapseCard"
        >
          {answers}
        </Collapse>
        <Divider y={2} volume={0} />
      </>
    );
  });
}

export default PostsView;
